import { DefaultTeamLogo, useAppTheme, useIntl } from '@capsicum/common';
import { Avatar, TopBar, TopBarIcon, useRouter } from '@capsicum/common-web';
import { ChevronLeftBoldIcon } from '@capsicum/common-web/icons';
import styled from 'styled-components';

type SurveyBannerProps = {
	introductionText?: string;
	partnerLogo?: string;
	partnerName: string;
};

export const SurveyBanner = ({ introductionText, partnerLogo, partnerName }: SurveyBannerProps) => {
	const { $t } = useIntl();
	const { back } = useRouter();
	const { mode } = useAppTheme();

	const isDark = mode === 'dark';

	return (
		<S.SurveyBannerContainer>
			<S.TopBarContainer>
				<TopBar
					backgroundColor="transparent"
					headerLeft={[
						<TopBarIcon
							bordered
							forceTheme="dark"
							icon={ChevronLeftBoldIcon}
							key="1"
							testID="SurveyBanner-topBar-backIcon"
							onClick={() => back()}
						/>
					]}
					testID="SurveyBanner-topBar"
					title=""
					variant="subpage"
				/>
			</S.TopBarContainer>
			<S.AvatarTextGroup>
				<Avatar size="XXL" src={partnerLogo || DefaultTeamLogo} />
				<S.StyledTitle $isDark={isDark}>
					{introductionText || $t('survey.banner.text', { partnerName: partnerName })}
				</S.StyledTitle>
			</S.AvatarTextGroup>
		</S.SurveyBannerContainer>
	);
};

namespace S {
	export const SurveyBannerContainer = styled.div`
		box-sizing: border-box;
		width: 100%;
		position: relative;
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			padding: 0 ${({ theme }) => theme.spacings.small};
		}
		margin-bottom: ${({ theme }) => theme.spacings.large};
	`;

	export const TopBarContainer = styled.div`
		margin: 0 auto;
		width: 100%;

		${({ theme }) => theme.breakpoints.queries.above.tabletSmallDesktop} {
			width: 560px;
			padding: ${({ theme }) => `0 ${theme.spacings.small}`};
		}
	`;

	export const AvatarTextGroup = styled.div`
		display: flex;
		flex-direction: column;
		row-gap: ${({ theme }) => theme.spacings.large};
		align-items: center;
		justify-content: center;
		position: relative;
	`;

	export const StyledTitle = styled.h1<{ $isDark: boolean }>`
		${({ theme }) => theme.fonts.headings.title6};
		color: ${({ $isDark, theme }) => ($isDark ? theme.colors.text.main.enabled : theme.colors.text.main.inverse)};
		text-align: center;
		margin: 0;
		padding: 0 60px;
	`;
}
